import { render } from "./DeleteProfile.vue?vue&type=template&id=4b7ba438&scoped=true"
import script from "./DeleteProfile.vue?vue&type=script&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&lang=js"

import "./DeleteProfile.vue?vue&type=style&index=0&id=4b7ba438&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7ba438"]])

export default __exports__